import $http from '@/config/http'
import { setHttpData } from '@config/makeRequest'
import dataTable from '@config/dataTable'

//获取服务器时间
export const getServerTime = () => {
  return new Promise((resolve, reject) => {
    $http.post('', { domain: 'cdel', resourcePath: '+/server/time' })
      .then(res => {
        const { data } = res
        if (data.success) {
          resolve(data.result)
        } else {
          reject({ msg: '获取服务器时间失败' })
        }
      }).catch(() => {
      reject({ msg: '获取服务器时间失败' })
    })
  })
}

// 获取公匙
export const getPublicKey = () => {
  return new Promise((resolve, reject) => {
    $http.post('/', {
      params: {
        time: (new Date).getTime()
      },
      domain: 'cdel',
      resourcePath: '+/key/public',
      platform: '',
      appType: '',
      appVersion: ''
    })
      .then(res => {
        const { data } = res
        if (data.success) {
          resolve(data.result)
        } else {
          reject({ msg: '获取公钥失败' })
        }
      })
      .catch(() => {
        reject({ msg: '获取公钥失败' })
      })
  })
}

//获取是否有临时保存试卷
export const checkTempPaper = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/checkTempRecord', params)
      .then(res => {
        if (res.success) {
          const { result } = res
          resolve(result)
        } else {
          reject({ msg: '获取临时保存信息失败' })
        }
      }).catch(() => {
      reject({ msg: '获取临时保存信息失败' })
    })
  })
}
//删除临时保存试卷
export const deleteTempRecord = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/deleteTempRecord', params)
      .then(res => {
        if (res.success) {
          const { result } = res
          resolve(result)
        } else {
          reject({ msg: '获取临时保存信息失败' })
        }
      }).catch(() => {
      reject({ msg: '获取临时保存信息失败' })
    })
  })
}

//正式组卷
export const getAllInformation = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/buildPaper', params)
      .then(res => {
        if(res.success) {
          const { result } = res
          let constructorDataList = dataTable.encodeData(result)
          resolve(constructorDataList)
        } else {
          if(res.errorCode === '-1' && res.errorMsg) {
            reject({ msg:res.errorMsg, errorCode:res.errorCode })
          } else {
            reject({ msg: '获取试卷信息失败' })
          }
        }
      }).catch(() => {
      reject({ msg: '获取试卷信息失败' })
    })
  })
}
//临时组卷
export const getAllInformationTemp = (params) => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/buildPaperTemp', params)
      .then(res => {
        if(res.success) {
          const { result } = res
          let constructorDataList = dataTable.encodeData(result)
          resolve(constructorDataList)
        } else {
          if(res.errorCode === '-1' && res.errorMsg) {
            reject({ msg:res.errorMsg, errorCode:res.errorCode })
          } else {
            reject({ msg: '获取试卷信息失败' })
          }
        }
      }).catch(() => {
      reject({ msg: '获取试卷信息失败' })
    })
  })
}

// 查看解析
export const quesAnaly = (params) => {
  return new Promise((resolve, reject) => {
    let resultData
    setHttpData('/exam/getPaperAnalysis', params)
    .then(res => {
      if (res.icode === '-1') {
        return resultData
      }
      let { result } = res
      if (res.success) {
        let constructorDataList = dataTable.encodeData(result)
        let newTypeShowMap = {}
        constructorDataList.quesShowList.forEach((item) => {
          if (Object.keys(newTypeShowMap).indexOf('sort' + item.relOrder) === -1) {
            newTypeShowMap['sort' + item.relOrder] = result.quesTypeShowMap[item.relOrder]
          }
        })
        constructorDataList.quesTypeShowMap = newTypeShowMap
        resolve(constructorDataList)
      } else {
        reject({ msg: '解析数据获取失败' })
      }
    }).catch(() => {
      reject({ msg: '解析数据获取失败' })
    })

  })
}

//提交试卷
export const savePaper = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/savePaper',params)
    .then(res => {
      let { result } = res
      if(res.success) {
        resolve(result)
      } else {
        if(res.errorCode === '-1' && res.errorMsg) {
          reject({ msg:res.errorMsg, errorCode:res.errorCode })
        } else {
          reject({ msg: '提交试卷失败' })
        }
      }
    }).catch(() => {
      reject({ msg: '提交试卷失败' })
    })
  })
}

//临时保存
export const saveTemp = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/savePaperTemp',params)
    .then(res => {
      let { result } = res
      if (res.success) {
        resolve(result)
      } else {
        reject({ msg: '临时保存失败' })
      }
    }).catch(() => {
      reject({ msg: '临时保存失败' })
    })
  })
}
//---------------------------------------------
//获取类别和辅导集合
export const getCategoryMajors = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getCategoryMajors',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取辅导失败' })
        }
      }).catch(() => {
      reject({ msg: '获取辅导失败' })
    })
  })
}
//获取试卷列表
export const getPapers = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getPapers',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取试卷列表失败' })
        }
      }).catch(() => {
      reject({ msg: '获取试卷列表失败' })
    })
  })
}
//获取做题记录列表
export const getRecords = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getRecords',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取做题记录列表失败' })
        }
      }).catch(() => {
      reject({ msg: '获取做题记录列表失败' })
    })
  })
}
//获取收藏列表记录
export const getFavs = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getFavs',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取收藏列表失败' })
        }
      }).catch(() => {
      reject({ msg: '获取收藏列表失败' })
    })
  })
}
//获取收藏记录对应的类别和辅导
export const getFavCategoryMajors = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/getFavCategoryMajors',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '获取收藏记录类别失败' })
        }
      }).catch(() => {
      reject({ msg: '获取收藏记录类别失败' })
    })
  })
}
//取消收藏
export const deleteFavQues = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/deleteFavQues',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '取消收藏失败' })
        }
      }).catch(() => {
      reject({ msg: '取消收藏失败' })
    })
  })
}

//添加收藏
export const addFavQues = params => {
  return new Promise((resolve, reject) => {
    setHttpData('/exam/addFavQues',params)
      .then(res => {
        let { result } = res
        if (res.success) {
          resolve(result)
        } else {
          reject({ msg: '添加收藏失败' })
        }
      }).catch(() => {
      reject({ msg: '添加收藏失败' })
    })
  })
}
